import { render, staticRenderFns } from "./CheckConfigForm.vue?vue&type=template&id=237ee254&scoped=true"
import script from "./CheckConfigForm.vue?vue&type=script&lang=js"
export * from "./CheckConfigForm.vue?vue&type=script&lang=js"
import style0 from "./CheckConfigForm.vue?vue&type=style&index=0&id=237ee254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ee254",
  null
  
)

export default component.exports